<h2>{{ title }}</h2>
<p *ngIf="desc" class="desc">{{ desc }}</p>
<p *ngIf="details" class="details">
  <ng-container *ngIf="!mailToAddr; else detailsLink">{{ details }}</ng-container>
</p>
<ng-template #detailsLink>{{ details }} <a href="mailto:{{ mailToAddr }}">{{ mailToAddr }}</a> !</ng-template>
